var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.project
    ? _c("div", { staticClass: "project-map__card" }, [
        _c("img", {
          staticClass: "project-map__card__image",
          attrs: { src: _vm.project.image },
          on: { click: _vm.visitProject }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "project-map__card__content" }, [
          _c("h2", { staticClass: "project_map__card__title" }, [
            _c("a", { attrs: { href: _vm.project.url } }, [
              _vm._v(_vm._s(_vm.project.title))
            ])
          ]),
          _vm._v(" "),
          _vm.project.completion_date
            ? _c("div", [
                _c("p", { staticClass: "project-map__label" }, [
                  _vm._v("Year")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "project-map__value" }, [
                  _vm._v(_vm._s(_vm.project.completion_date))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.project.project_value
            ? _c("div", [
                _c("p", { staticClass: "project-map__label" }, [
                  _vm._v("Project value")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "project-map__value" }, [
                  _vm._v(_vm._s(_vm.project.project_value))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.project.project_size
            ? _c("div", [
                _c("p", { staticClass: "project-map__label" }, [
                  _vm._v("Project size")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "project-map__value" }, [
                  _vm._v(_vm._s(_vm.project.project_size))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.project.cost_per_square
            ? _c("div", { staticClass: "project-map__label" }, [
                _c("p", { staticClass: "project-map__label" }, [
                  _vm._v("Cost per sq.m")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "project-map__value" }, [
                  _vm._v(_vm._s(_vm.project.cost_per_square))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.project.program
            ? _c("div", [
                _c("p", { staticClass: "project-map__label" }, [
                  _vm._v("Programme")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "project-map__value" }, [
                  _vm._v(_vm._s(_vm.project.program))
                ])
              ])
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b0fce2a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b0fce2a","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!/var/www/costimise/wp-content/themes/costimise/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/projects-map/ProjectMapCard.vue
// module id = 162
// module chunks = 0